var map = {
	"./ar.json": 7112,
	"./bg.json": 2437,
	"./cs.json": 9305,
	"./de.json": 5931,
	"./en.json": 5678,
	"./es.json": 8004,
	"./fr.json": 7162,
	"./he.json": 3889,
	"./it.json": 4490,
	"./ja.json": 6349,
	"./kaa.json": 3050,
	"./pl.json": 8491,
	"./pt.json": 5234,
	"./ru.json": 4044,
	"./sv.json": 970,
	"./tr.json": 2420,
	"./zh.json": 5299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9542;